import { menusClient } from '../../../app/services/api/menus';

const useMenusApi = () => {
  return menusClient;
};

export default useMenusApi;
